import * as actionTypes from './actionTypes'
import * as actionStatuses from './actionStatuses'

export function stageGetInitData(payload: any) {
    return {
        type: actionTypes.STAGE_GET_INIT_DATA,
        payload
    }
}

export function saveInitDataFlag(payload: any) {
    return {
        type: actionTypes.SAVE_INIT_DATA_FLAG,
        payload
    };
}

const sendRequestActionCreator = (status: any, payload: any, error: any) => {
    return {
        type: actionTypes.SEND_GET_INIT_DATA,
        status: status,
        payload: payload,
        error: error
    };
}

export function stageReportingEventInitData(payload: any) {
    return {
        type: actionTypes.STAGE_REPORTING_EVENT_INIT_DATA,
        payload
    }
}


export function saveInitData(payload: any) {
    return {
        type: actionTypes.SAVE_INIT_DATA,
        payload
    }
}

export function savePreAuthInitData(payload: any) {
    return {
        type: actionTypes.SAVE_PRE_AUTH_INIT_DATA,
        payload
    }
}

export function saveProductPayload(productPayload: any, stateLocation: string, productSavedLocation: string, accessKeyLocation: string | null | undefined) {
    return {
        type : actionTypes.SAVE_PRODUCT_PAYLOAD,
        payload : {
        stateLocation,
        productPayload,
        productSavedLocation,
        accessKeyLocation
        }
    }
}


export function setResetFunctionFlag(stateLocation: string, value: boolean){
    return {
        type : actionTypes.SET_RESET_FUNCTION_FLAG,
        payload : {
        stateLocation,
        value
        }
    }
}

export function setUDPVars(stateLocation: string, value: any) {
    return {
        type: actionTypes.SET_UDP_VARS,
        payload: {
            stateLocation,
            value
        }
    }
}


export function saveUserAdvocacy(stateLocation: string, value: any) {
    return {
        type: actionTypes.SAVE_USER_ADVOCACY_AVAILABILITY,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setUserInfoInitializeComplete(stateLocation: string)
{
    return {
        type : actionTypes.SET_USER_INITIALIZE_COMPLETE,
        payload : {
            stateLocation
        }
    }
}



// WEBPACK FOOTER //
// ./modules/initialization-data-handler/actions/actions.ts